export default {
  '--badge-default-color': '#555'
};